import { InjectionToken } from "@angular/core";
import { getRouterSelectors, routerReducer } from "@ngrx/router-store";
import * as fromRouter from '@ngrx/router-store';
import { globalReducer } from "./reducers/global.reducer";
import { garageReducer, GarageState } from "./reducers/garage.reducer";
import { createSelector } from "@ngrx/store";
import { ScreenWidth } from "./models/screenWidth.model";
import { IUser } from "./models/IUser.model";
import { UserDetail } from "../models/UserDetail.model";

export enum AppBreakpoints {
  xs = 0,
  sm = 576,
  md = 768,
  lg = 991,
  xl = 1200,
  xxl = 1600
};

export enum PricingStrings {
  CurrencyCode = 'currency_code',
  FormattedAmount = 'formatted_amount',
  FormattedCompareAt = 'formatted_compare_at',
  FormattedOriginalAmount = 'formatted_original_amount'
};

export interface GlobalState {
  screenWidth?: ScreenWidth,
  containerType?: 'normal' | 'fluid',
  showLoadingMask?: boolean,
  user?: IUser,
  userDetail?: UserDetail,
  permissions?: string[],
  userSearchResults?: { [userId: string]: UserDetail }
};

export interface AppState {
  garageState: GarageState,
  globalState: GlobalState,
  router: fromRouter.RouterReducerState
};

export const ROOT_REDUCER = new InjectionToken<any>('Root Reducer', {
  factory: () => ({
    garageState: garageReducer,
    globalState: globalReducer,
    router: routerReducer
  })
});

export const {
  selectCurrentRoute, // select the current route
  selectFragment, // select the current route fragment
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectRouteDataParam, // factory function to select a route data param
  selectUrl, // select the current url
  selectTitle, // select the title if available
} = getRouterSelectors();

export const selectContainerType = (state: AppState) => state.globalState.containerType;
export const selectScreenWidth = (state: AppState) => state.globalState.screenWidth;
export const selectShowLoadingMask = (state: AppState) => state.globalState.showLoadingMask;
// export const selectUser = (state: AppState) => state.globalState.user;
export const selectUserDetail = (state: AppState) => state.globalState.userDetail;
export const selectPermissions = (state: AppState) => state.globalState.permissions;

// User search selectors
const selectUserSearchResultsMap = (state: AppState) => state.globalState.userSearchResults;
export const selectUserSearchResults = createSelector(
  selectUserSearchResultsMap,
  (userSearchResultsMap) => userSearchResultsMap ? Object.values(userSearchResultsMap) : null
);
export const selectUserDetailById = (userId: string) =>
  createSelector(
    selectUserSearchResultsMap,
    (userSearchResultsMap) => userSearchResultsMap?.[userId]
  );

// Garage selectors
export const selectVehicles = (state: AppState) => state.garageState.vehicles;
export const selectVehiclesLoading = (state: AppState) => state.garageState.loading;
export const selectVehiclesError = (state: AppState) => state.garageState.error;
export const selectVehicleDetailsMap = (state: AppState) => state.garageState.vehicleDetailsMap;
export const selectVehicleDetailById = (vehicleId: string) =>
  createSelector(
    selectVehicleDetailsMap,
    (vehicleDetailsMap) => vehicleDetailsMap[vehicleId]
  );

// Pagination selectors
export const selectCurrentPage = (state: AppState) => state.garageState.currentPage;
export const selectPageSize = (state: AppState) => state.garageState.pageSize;
export const selectTotalPages = (state: AppState) => state.garageState.totalPages;
export const selectSort = (state: AppState) => state.garageState.sort;
export const selectSortDir = (state: AppState) => state.garageState.sortDir;
// export const selectUserWithPermissions = createSelector(
//   selectUser,
//   selectPermissions,
//   (user, permissions) => {
//     return { user, permissions };
//   }
// );
export const selectUserDetailWithPermissions = createSelector(
  selectUserDetail,
  selectPermissions,
  (userDetail, permissions) => {
    return { userDetail, permissions };
  }
);
// export const selectAppComponentData = createSelector(
//   selectUser,
//   selectUserDetail,
//   selectPermissions,
//   (user, userDetail, permissions) => {
//     return { user, userDetail, permissions };
//   }
// );
